import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import {
  share,
  type ShareOptions,
  type ShareResult,
} from "@src/appV2/NativeAdapters/share.adapter";
import { useMutation } from "@tanstack/react-query";

import { type InviteMessage } from "../types";

interface ShareProfessionalReferenceParams {
  inviteMessage: InviteMessage;
}

export function useShareProfessionalReference() {
  return useMutation<ShareResult | undefined, unknown, ShareProfessionalReferenceParams>({
    mutationFn: async ({ inviteMessage }) => {
      const data: Pick<ShareOptions | ShareData, "title" | "text"> = {
        title: "Professional Reference Request",
        text: `${inviteMessage.messageText} ${inviteMessage.webFormLink}`,
      };

      // The adapter handles platform-specific behavior internally
      return await share(data);
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.SHARE_PROFESSIONAL_REFERENCE_FAILURE,
    },
  });
}
